module.exports = __webpack_public_path__ + "img/bg_login-wechat.c8463a5c.svg";